import envInnuvaCredentials from "./envInnuva";
import axios from "axios";

const { credentials, authorizationParams } = envInnuvaCredentials();

export async function CallWKAAuthServer() {

    const authorizationUrl = `https://login.wolterskluwer.eu/auth/core/connect/authorize?client_id=${authorizationParams.CLIENT_ID}&response_type=code+id_token&redirect_uri=${authorizationParams.REDIRECT_URI}&scope=offline_access+openid+IDInfo+WK.ES.A3EquipoContex&state=${authorizationParams.STATE}&nonce=${authorizationParams.NONCE}`;

    window.location.href = authorizationUrl;
    // openCenteredWindow(authorizationUrl, 'AuthorizationWindow', 600, 700);
}

// function openCenteredWindow(url, title, width, height) {
//     // Calcular la posición central usando medidas relativas
//     const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
//     const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

//     const screenWidth = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
//     const screenHeight = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

//     const left = ((screenWidth - width) / 2) + dualScreenLeft;
//     const top = ((screenHeight - height) / 2) + dualScreenTop;

//     // Abrir la ventana emergente
//     const windowFeatures = `scrollbars=yes, width=${width}, height=${height}, top=${top}, left=${left}`;
//     const newWindow = window.open(url, title, windowFeatures);

//     // Enfocar la nueva ventana si se abrió correctamente
//     if (newWindow) {
//         newWindow.focus();
//     }
// }


export async function getAccessToken(code) {

    const req = 'https://login.wolterskluwer.eu/auth/core/connect/token';

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };

    const data = {
        client_id: authorizationParams.CLIENT_ID,
        client_secret: credentials.CLIENT_SECRET,
        code: code,
        grant_type: 'authorization_code',
        redirect_uri: authorizationParams.REDIRECT_URI
    }

    const response = await axios.post(req, data, config, {});

    const accessToken = response.data.access_token;

    sessionStorage.removeItem('code');

    sessionStorage.setItem('accessToken', accessToken);

    return accessToken;

}

export async function getInnuvaCompanies(accessToken) {
    let pageNumber = 1;
    const pageSize = 50;
    const allCompanies = [];
    const reqBase = 'https://a3api.wolterskluwer.es/Laboral/api/companies?';
    const config = {
        headers: {
            'Ocp-Apim-Subscription-Key': credentials.API_KEY,
            'Content-Type': 'application/json',
            'Api-version': '1.0',
            'Authorization': accessToken
        }
    };

    try {
        while (true) {
            const req = `${reqBase}pageNumber=${pageNumber}&pageSize=${pageSize}`;
            const response = await axios.get(req, config);

            if (response.data && response.data.length > 0) {
                const companyData = response.data.map(company => ({
                    nifCif: company.identifierNumber,
                    name: company.companyName,
                    responsibleId: ''
                }));
                allCompanies.push(...companyData);
                pageNumber++;
            } else {
                break; // No more data to fetch
            }
        }

        return { success: true, data: allCompanies };
    } catch (error) {
        if (error.response && error.response.status === 401) {
            return { success: false, error: 'Unauthorized' };
        }
        return { success: false, error: error.message };
    }
}

